<nz-modal
  [nzVisible]="isWarningModalVisible"
  [nzTitle]="modalHeaderTemplate"
  [nzFooter]="modalFooterTemplate"
  (nzOnCancel)="warningCancel.emit()"
  nzWidth="400px"
  nzCentered>
  <ng-template #modalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Warning</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Whenever challenging behavior poses a threat to the safety of the
        student or to others in the environment, the program should be closely
        monitored by an individual with specific expertise in managing such
        behavior. If you lack such expertise, please involve an appropriate
        person in reviewing the behaviors and possible interventions before
        implementing this plan. Contact your administration if you are unsure
        who to involve in this capacity.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>
  <ng-template #modalFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="warningCancel.emit()"
        class="justify-content-center">
        I Understand
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [nzVisible]="isFunctionalEquivalentModalVisible"
  [nzTitle]="functionalHeaderTemplate"
  [nzFooter]="functionalFooterTemplate"
  (nzVisibleChange)="functionalEquivalentVisibleChange.emit($event)"
  (nzOnCancel)="functionalEquivalentVisibleChange.emit(false)"
  nzWidth="400px"
  nzCentered>
  <ng-template #functionalHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Functional Equivalent</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        Two or more behaviors that serve the same purpose, or function, for the
        student. Behaviors that look much different from one another can still
        be functionally equivalent. For example, hitting others and screaming
        could be functionally equivalent if a student used both of these
        behaviors as a way to get out of doing work.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>
  <ng-template #functionalFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="functionalEquivalentVisibleChange.emit(false)"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [nzVisible]="isSettingEventModalVisible"
  [nzTitle]="settingHeaderTemplate"
  [nzFooter]="settingFooterTemplate"
  (nzVisibleChange)="settingEventVisibleChange.emit($event)"
  (nzOnCancel)="settingEventVisibleChange.emit(false)"
  nzWidth="400px"
  nzCentered>
  <ng-template #settingHeaderTemplate>
    <div class="modal-header">
      <div class="modal-icon modal-icon-orange">
        <svg-icon
          src="/assets/icon/icon-info.svg"
          class="icon s-20"
          aria-label="Info"></svg-icon>
      </div>
      <h3 class="ant-modal-title">Setting Events</h3>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        An event or condition under which a student is more likely to engage in
        challenging behavior. A setting event does not directly cause a
        challenging behavior, but rather increases the likelihood that something
        will trigger the challenging behavior. For example, if a student is
        hungry they are more likely to try and get food when they see it. In
        this case, being hungry is the setting event, while seeing food is what
        triggers the behaviors.
      </p>
      <svg-icon
        src="/assets/icon/icon-modal-circle.svg"
        class="icon s-20 circle-pattern"
        aria-label="Modal Circle"></svg-icon>
    </div>
  </ng-template>
  <ng-template #settingFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="settingEventVisibleChange.emit(false)"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  class="goal-example-modal"
  [nzVisible]="isGoalExampleModalVisible"
  [nzTitle]="goalExampleTemplate"
  [nzFooter]="goalExampleFooterTemplate"
  (nzVisibleChange)="goalExampleVisibleChange.emit($event)"
  (nzOnCancel)="goalExampleVisibleChange.emit(false)"
  nzWidth="700px"
  nzCentered>
  <ng-template #goalExampleTemplate>
    <div class="modal-header goal-example-modal-header">
      <h3 class="ant-modal-title">Positive and Measurable Behavioral Goals</h3>
      <br />
      <p
        class="text s-14 fw-400 ant-modal-subtitle"
        *ngFor="
          let goal of behaviorGoalExamples.behavioral_goals;
          trackBy: trackByGoal
        ">
        <span
          ><b
            ><u>{{ goal.goal }}</u></b
          >: {{ goal.description }}</span
        >
        <br />
        <br />
      </p>
      <p class="text s-14 fw-400 ant-modal-subtitle">
        {{ behaviorGoalExamples.note }}
      </p>
    </div>
  </ng-template>
  <ng-template #goalExampleFooterTemplate>
    <div class="modal-footer">
      <button
        nzBlock
        nz-button
        nzType="primary"
        (click)="goalExampleVisibleChange.emit(false)"
        class="justify-content-center">
        Close
      </button>
    </div>
  </ng-template>
</nz-modal>

<nz-modal
  [nzVisible]="isPdfModalVisible"
  [nzTitle]="pdfModalHeaderTemplate"
  [nzFooter]="pdfModalFooterTemplate"
  (nzVisibleChange)="pdfVisibleChange.emit($event)"
  (nzOnCancel)="pdfVisibleChange.emit(false)"
  nzWidth="600px"
  nzCentered>
  <ng-template #pdfModalHeaderTemplate>
    <embed
      src="/assets/samplefiles/MASTERITBOperationalDefinitionsExamples.pdf#toolbar=0"
      type="application/pdf"
      width="100%"
      height="500px" />
  </ng-template>
  <ng-template #pdfModalFooterTemplate></ng-template>
</nz-modal>
